import clsx from "clsx";
import Helper from "../../../../utils/Helper";
import CustomConfirmationModal from "../../../../components/CustomConfirmationModal";
import { Container } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as authSelectors from "../../../../selectors/auth";
import _ from "lodash";
import * as ipoSelectors from "../../../../selectors/ipo";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router";
import * as StorageManager from "../../../../utils/StorageManager";
import constants from "../../../../constants";
import { useQuery } from "@tanstack/react-query";
import * as axiosInstance from "../../../../services/axiosInstance";
import Table from "react-bootstrap/Table";
import EmptyItemView from "../../../../components/EmptyItemView";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import { getSetOffDataDate } from "../../../../selectors/set-off";
import * as setOffSelectors from "../../../../selectors/set-off";
import {
  getIpoDetailBalanceAmount,
  getIpoDetailBalanceAmountValue,
  getIpoDetailOriginalAmount,
  getIPODetailStatus,
  getSubscribedIPODetailsNumberOfShareAllottedText,
  getSubscribedIPODetailsTotalAmountAllottedText,
  getSubscribedIPODetailsTotalAmountAllottedValue,
  getSubscribedIPODetailsTotalAmountRefundedText,
  getSubscribedIPODetailsTotalBalanceTrustAmount,
  getSubscribedIPODetailsTotalBalanceTrustAmountValue,
  getSubscribedIPODetailsTotalOriginalTrustAmount,
  getSubscribedIPODetailsTotalOriginalTrustAmountValue,
  getSubscribedIPODetailsTotalTransactionTrustAmount
} from "../../../../selectors/ipo";
import * as ipoActions from "../../../../action/ipo";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowDown} from "@fortawesome/free-solid-svg-icons";

function EIPOHistoryDetail() {
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(false);
  const [confirmationModalShow, setConfirmationModalShow] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [deleteUrl, setDeleteUrl] = useState("");

  const isLogout = useSelector((state) => authSelectors.getAuthIsLogout(state));
  const dispatch = useDispatch();
  const { ipoID } = useParams();
  const history = useHistory();
  useEffect(() => {
    setTokenFunction();
  }, [isLogout]);

  async function setTokenFunction() {
    setToken(await StorageManager.retrieveToken(constants.AUTH_TOKEN));
  }
  const { data, isLoading ,refetch} = useQuery({
    queryKey: ["subscribe-ipo-detail", { ipoID }],
    queryFn: async () => {
      try {
        return await axiosInstance.get(`/clientarea/ipo/subscription/${ipoID}`);
      } catch (e) {
        const error = _.get(e, ["status"]);
        if (error == "404") {
          setNotFound(true);
        }
        Helper.handleHttpError(e, dispatch, history);
      }
    },
    retryDelay: 15000,
    enabled: !_.isEmpty(token) && !_.isEmpty(ipoID),
  });

  const onHandleBack = () => {
    history.goBack(null);
  };


  const onClickDelete =  (url) => {
    setConfirmationModalShow(true);
    refetch().then()
    setDeleteUrl(url);
  };

  const onConfirm = async () => {
    setLoading(true);
    try {
      const result = await axiosInstance.del(`${deleteUrl}`);
      await refetch()
      dispatch(ipoActions.removeIpoConfig());

      return result;
    } catch (e) {
    } finally {
      setLoading(false);
      setConfirmationModalShow(false);
      setDeleteUrl("");
    }
  };

  const ipoData = _.get(data, ["data", "ipo"], []);
  const itemData = _.get(data, ["data"], null);
  const contracts = _.get(itemData,['contracts'],[]);
  const stockCode = ipoSelectors.getIPODetailStockCode(ipoData);
  const stockName = ipoSelectors.getIPODetailStockName(ipoData);
  const pricePerShare = ipoSelectors.getIPODetailPricePerShare(ipoData);
  const finalPricePerShare =
      ipoSelectors.getIPODetailFinalPricePerShare(ipoData);
  const priceChanged = ipoSelectors.getIPODetailPriceChanged(ipoData);
  const lotSize = ipoSelectors.getIPODetailLotSizeValue(ipoData);
  const issueNo = ipoSelectors.getIPODetailIssueNo(ipoData);

  const race = ipoSelectors.getSubscribedIPODetailsRaceText(itemData);
  const applicationStatus = ipoSelectors.getSubscribedIPODetailsApplicationStatus(itemData);
  const numberOfShareAppliedText =
    ipoSelectors.getSubscribedIPODetailsNumberOfShareAppliedText(itemData);
  const totalAmountAppliedText =
    ipoSelectors.getSubscribedIPODetailsTotalAmountAppliedText(itemData);
  const totalAmountApplied =
    ipoSelectors.getSubscribedIPODetailsTotalAmountAppliedValue(itemData);

  const numberOfShareAllottedText =
      ipoSelectors.getSubscribedIPODetailsNumberOfShareAllottedText(itemData);
  const totalAmountAllottedText =
      ipoSelectors.getSubscribedIPODetailsTotalAmountAllottedText(itemData);
  const totalAmountAllotted =
      ipoSelectors.getSubscribedIPODetailsTotalAmountAllottedValue(itemData);
  const totalAmountRefundedText =
      ipoSelectors.getSubscribedIPODetailsTotalAmountRefundedText(itemData);
  const symbol =
    ipoSelectors.getSubscribedIPODetailsCurrencyCodeSymbol(itemData);
  const isCancellable =
    setOffSelectors.getSubmittedContractIsCancellable(itemData);
  const cancelLink =
    setOffSelectors.getSubmittedContractCancelLink(itemData);
  const totalOriginalAmount = ipoSelectors.getSubscribedIPODetailsTotalOriginalTrustAmount(itemData)
  const totalBalanceAmount = ipoSelectors.getSubscribedIPODetailsTotalBalanceTrustAmount(itemData)
  const totalOriginalAmountValue = ipoSelectors.getSubscribedIPODetailsTotalOriginalTrustAmountValue(itemData)
  const totalBalanceAmountValue = ipoSelectors.getSubscribedIPODetailsTotalBalanceTrustAmountValue(itemData)
  console.log(totalBalanceAmountValue, totalAmountApplied);
  return (
    <Container fluid>
      <div className="ipo-detail-container">
        <div className="d-flex justify-content-between">
          <div className="ipo-title">{applicationStatus}</div>
          {isCancellable ? <button
              className={clsx("btn custom-button-white small long mx-2")}
              onClick={(e) => {
                e.preventDefault();
                onClickDelete(cancelLink);
              }}
              // disabled={!isCancellable}
          >
            Cancel
          </button> : false}
        </div>
        {
          finalPricePerShare ? (
              <div className={"primary-border-table-border mt-4"}>
                <div
                    className={clsx(
                        "d-flex custom-card-label-container align-items-center justify-content-center",
                    )}
                >
                  <h2>Result</h2>
                </div>
                <div
                    className={clsx("custom-table-info-container padding-12px mt-3")}
                >
                  <div className="ipo-subscribe-container">
                    <div className="ipo-subscribe-detail-container">
                      <div className="ipo-subscribe-content" style={{flex: 2}}>
                        <div className="ipo-subscribe-content-title">Share</div>
                        <div
                            className="ipo-subscribe-content-text"
                            style={{
                              flexDirection: "column",
                              alignItems: "flex-start",
                            }}
                        >
                          <div>
                            <b>{stockName}</b>
                          </div>
                          <div>{stockCode}</div>
                        </div>
                      </div>
                      <div className="ipo-subscribe-content" style={{flex: 2}}>
                        <div className="ipo-subscribe-content-title">Issue No</div>
                        <div className="ipo-subscribe-content-text">{issueNo}</div>
                      </div>
                      <div className="ipo-subscribe-content" style={{flex: 2}}>
                        <div className="ipo-subscribe-content-title">Share Price</div>
                        <div className="ipo-subscribe-content-text">{finalPricePerShare}</div>
                      </div>
                      <div className="ipo-subscribe-content" style={{flex: 2}}>
                        <div className="ipo-subscribe-content-title">Race</div>
                        <div className="ipo-subscribe-content-text">{race}</div>
                      </div>
                      <div className="ipo-subscribe-content" style={{flex: 2}}>
                        <div className="ipo-subscribe-content-title">
                          Subscription Method
                        </div>
                        <div className="ipo-subscribe-content-text">Trust Money</div>
                      </div>
                      <div className="ipo-subscribe-content" style={{flex: 2}}>
                        <div className="ipo-subscribe-content-title">
                          Allotted Units (x{lotSize})
                        </div>
                        <div className="ipo-subscribe-content-text">
                          {numberOfShareAllottedText}
                        </div>
                      </div>
                    </div>
                    <div className="ipo-subscribe-detail-container justify-content-end">
                      <div className="d-flex total-price-container total-price-container-mobile">
                        <div className="ipo-subscribe-total-container justify-content-end mt-2">
                          <div className="w-100">Total Refund Amount</div>
                          <div className="ipo-price-value">
                            {_.isEmpty(totalAmountRefundedText) ? '-' : totalAmountRefundedText}
                          </div>
                        </div>
                        <div className="ipo-subscribe-total-container justify-content-end mt-2">
                          <div className="w-100">Total Allotted Amount</div>
                          <div className="ipo-price-value">
                            {_.isEmpty(totalAmountAllottedText) ? '-' : totalAmountAllottedText}
                          </div>
                        </div>
                        <div className="divider-ipo mt-2"></div>
                        <div className="ipo-subscribe-total-container justify-content-end mt-2">
                          <div className="w-100">Total Subscription Amount</div>
                          <div className="ipo-price-value">
                            {totalAmountAppliedText}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          ) : false
        }
        <div className={"primary-border-table-border mt-4"}>
          <div
              className={clsx(
                  "d-flex custom-card-label-container align-items-center justify-content-center",
              )}
          >
            <h2>Subscribe</h2>
          </div>
          <div
              className={clsx("custom-table-info-container padding-12px mt-3")}
          >
            <div className="ipo-subscribe-container">
              <div className="ipo-subscribe-detail-container">
                <div className="ipo-subscribe-content" style={{flex: 2}}>
                  <div className="ipo-subscribe-content-title">Share</div>
                  <div
                      className="ipo-subscribe-content-text"
                      style={{
                        flexDirection: "column",
                        alignItems: "flex-start",
                      }}
                  >
                    <div>
                      <b>{stockName}</b>
                    </div>
                    <div>{stockCode}</div>
                  </div>
                </div>
                <div className="ipo-subscribe-content" style={{flex: 2}}>
                  <div className="ipo-subscribe-content-title">Issue No</div>
                  <div className="ipo-subscribe-content-text">{issueNo}</div>
                </div>
                <div className="ipo-subscribe-content" style={{flex: 2}}>
                  <div className="ipo-subscribe-content-title">Share Price</div>
                  <div className="ipo-subscribe-content-text">
                    <span>{pricePerShare}</span>
                    {priceChanged ? (
                        <span className="text-success ms-1" style={{fontSize: "10px"}}>
                          <FontAwesomeIcon icon={faArrowDown}/>
                          <span>{finalPricePerShare}</span>
                        </span>
                    ) : false}
                  </div>
                </div>
                <div className="ipo-subscribe-content" style={{flex: 2}}>
                  <div className="ipo-subscribe-content-title">Race</div>
                  <div className="ipo-subscribe-content-text">{race}</div>
                </div>
                <div className="ipo-subscribe-content" style={{flex: 2}}>
                  <div className="ipo-subscribe-content-title">
                    Subscription Method
                  </div>
                  <div className="ipo-subscribe-content-text">Trust Money</div>
                </div>
                <div className="ipo-subscribe-content" style={{flex: 2}}>
                  <div className="ipo-subscribe-content-title">
                    Number of Units (x{lotSize})
                  </div>
                  <div className="ipo-subscribe-content-text">
                    {numberOfShareAppliedText}
                  </div>
                </div>
              </div>
              <div className="ipo-subscribe-detail-container justify-content-end">
                <div className="d-flex total-price-container total-price-container-mobile">
                  <div className="ipo-subscribe-total-container justify-content-end">
                    <div className="w-100">Total Trust Amount</div>
                    <div className="ipo-price-value">{totalBalanceAmount}</div>
                  </div>
                  <div className="ipo-subscribe-total-container justify-content-end mt-2">
                    <div className="w-100">Total Subscription Amount</div>
                    <div className="ipo-price-value">
                      {totalAmountAppliedText}
                    </div>
                  </div>
                  <div className="divider-ipo mt-2"></div>
                  <div className="ipo-subscribe-total-container justify-content-end mt-2">
                    <div className="w-100">Balance Amount</div>
                    <div className="ipo-price-value">
                      {symbol}{" "}
                      {Number(totalBalanceAmountValue + totalAmountApplied).toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={"primary-border-table-border mt-4"}>
          <div
              className={clsx(
                  "d-flex custom-card-label-container align-items-center justify-content-center",
              )}
          >
            <h2>Trust Money</h2>
          </div>
          <div className={"responsive-table-border table-w-1400 mt-3"}>
            <div
                className={clsx(
                    "custom-table-info-container padding-12px mt-3 position-relative",
                )}
            >
              {!_.isEmpty(contracts) ? (
                  <Table responsive="lg">
                    <thead>
                    <tr className={"custom-table-setoff-styled"}>
                      <th style={{minWidth: 100}}>Date</th>
                      <th style={{minWidth: 160}}>Reference No</th>
                      <th style={{minWidth: 120}}>Stock Code</th>
                      <th style={{minWidth: 120}}>Stock Name</th>
                      <th style={{minWidth: 160}}>Total Amount</th>
                      <th style={{minWidth: 180}}>Balance Amount</th>
                      <th style={{minWidth: 160}}>Selected Amount</th>
                    </tr>
                    </thead>
                    <tbody>
                    {_.map(contracts, (item) => {
                      const dateDate = ipoSelectors.getIpoDetailDataDate(item);
                      const originalAmount =
                          ipoSelectors.getIpoDetailOriginalAmount(item);
                      const balanceAmount =
                          ipoSelectors.getIpoDetailBalanceAmount(item);
                      const transactionAmount =
                          ipoSelectors.getIpoDetailTransactionAmount(item);
                      const referenceNo =
                          ipoSelectors.getIpoDetailReferenceNo(item);
                      const originalAmountValue =
                          ipoSelectors.getIpoDetailOriginalAmountValue(item);
                      const balanceAmountValue =
                          ipoSelectors.getIpoDetailBalanceAmountValue(item);
                      const transactionAmountValue =
                          ipoSelectors.getIpoDetailTransactionAmountValue(item);
                      const symbol =
                          ipoSelectors.getIpoDetailCurrencyCodeSymbol(item);
                      return (
                          <tr>
                            <td>{dateDate}</td>
                            <td>{referenceNo}</td>
                            <td>-</td>
                            <td>-</td>
                            <td>{balanceAmount}</td>
                            <td>
                              {symbol}{" "}
                              {Number(balanceAmountValue - transactionAmountValue).toFixed(2)}
                            </td>
                            <td>{transactionAmount}</td>
                          </tr>
                      );
                    })}
                    </tbody>
                    <tfoot>
                    <tr>
                      <td colSpan={5}></td>
                      <td>
                        <b>Total Selected Amount</b>
                      </td>
                      <td>{totalAmountAppliedText}</td>
                    </tr>
                    </tfoot>
                  </Table>
              ) : (
                  <EmptyItemView></EmptyItemView>
              )}
              <LoadingOverlay
                  loading={data?.data?.loading}
                  loadingClass="loading-height"
              ></LoadingOverlay>
            </div>
          </div>
        </div>
      </div>
      <CustomConfirmationModal
          show={confirmationModalShow}
          title="Confirmation"
          desc="Are you sure you want to cancel this item?"
          confirm={onConfirm}
          loading={loading}
          handleClose={() => setConfirmationModalShow(false)}
      />
    </Container>
  );
}

export default EIPOHistoryDetail;
